import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { ISignpostingAwardBanner, ITokenSignposting } from './postbet-signposting.service';

@Component({
    selector: 'ms-postbet-signposting',
    templateUrl: 'postbet-signposting.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PostbetSignpostingComponent {
    @Input() banners: ISignpostingAwardBanner[];
    @Input() tokenSignPost?: ITokenSignposting;

    @HostBinding('class') className = 'postbet-signposting';
    title: string;

    constructor(sitecore: Sitecore) {
        this.title = sitecore.crmPostBetSignposting.messages.Awarded;
    }
}
